module.exports = __webpack_public_path__ + "static/media/404.a16e6765.jpg";